import { Outlet } from "@tanstack/react-router";
import { WalletSetupProvider } from "@/context/WalletSetupProvider";

export function AuthenticatedShell() {
  return (
    <WalletSetupProvider>
      <Outlet />
    </WalletSetupProvider>
  );
}
